<template>
    <div>
        
        <ul class="nav nav-pills" style="margin-bottom:15px;">
            <li class="nav-item">
                <router-link  :class="'nav-link '+isActive('VerPacote')" :to="{ name: 'VerPacote', params: {id: $route.params.id, carga:$route.params.carga} }" >Conjunto transportador</router-link>
            </li>
            <li class="nav-item">
                <router-link :class="'nav-link '+isActive('Documentos')" :to="{ name: 'Documentos', params: {id: $route.params.id, carga:$route.params.carga} }">Documentos</router-link>
            </li>
            <li class="nav-item">
                <router-link :class="'nav-link '+isActive('Autorizacoes')" :to="{ name: 'Autorizacoes', params: {id: $route.params.id, carga:$route.params.carga} }">Autorizações</router-link>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Programações</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Anotações</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Cronograma</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Ferramentas</a>
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name:"ConjuntoMenu",
    methods:{
        isActive(name){
            if(name==this.$route.name){
                return 'active'
            }
        }
    }
}
</script>

<style scoped>

</style>